// extracted by mini-css-extract-plugin
export default {"frame18":"styles_frame18__0MJ-i","frame19":"styles_frame19__HX7KF","textWrapper65":"styles_textWrapper65__XkIiC","textWrapper66":"styles_textWrapper66__OV4gQ"};